import { render, staticRenderFns } from "./admin.vue?vue&type=template&id=7c557cba"
import script from "./admin.vue?vue&type=script&lang=ts"
export * from "./admin.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports